import { z } from 'zod';
import {
    Snapshot,
    snapshotSchema,
    mockSnapshot,
} from 'app/agriculture/queries/snapshots/types/Snapshot';

export interface LevelSnapshot extends Snapshot {
    percentageRemaining: number | null;
    volumeRemaining: number | null;
    infrastructureId: string | null;
}

export const levelSnapshotSchema = snapshotSchema.extend({
    percentageRemaining: z
        .number()
        .transform((num) => Math.round(num))
        .nullable(), // Round the percentage to a whole number
    volumeRemaining: z.number().nullable(),
    infrastructureId: z.string().uuid().nullable(),
});

export const mockLevelSnapshot = ({
    percentageRemaining = 0,
    volumeRemaining = 0,
    infrastructureId = 'some-id',

    ...snapshot
}: Partial<LevelSnapshot> = {}): LevelSnapshot => ({
    ...mockSnapshot(snapshot),

    percentageRemaining,
    volumeRemaining,
    infrastructureId,
});
